// extracted by mini-css-extract-plugin
module.exports = {"scraperTasks":"AvailableTasks_scraperTasks__2OYWJ","header":"AvailableTasks_header__30JSL"};